import React from "react";
import currentTheme from "../../../react-themes/theme";
import {FarmyImage} from "../../../react-components/tools/nextjs-compatibility-layer";
import useWindowTools from "../../../react-hooks/useWindowTools";

const theme = currentTheme();

const DiscountBadge = (props) => {
  const {main_info_tags: infoTags = []} = props?.product;
  const {className = "", style = {}} = props;
  const {isMobile} = useWindowTools();

  const image = "icons/percentage-bold.svg";
  const iconWidths = theme.productIconWidths;

  const discount = infoTags.find(item => item.includes("%"))
    ? infoTags
      .find(item => item.includes("%"))
      .replace("%", "")
    : null;

  return discount
    ? <div
      className={`
        discount-badge
        default-square-badge
        flex
        align-items-center
        justify-content-center
        flex-shrink-0
        padding-5
        border-radius-sm
        ${className}
      `}
      style={{
        backgroundColor: theme.colors.discountColor,
        minHeight: `${iconWidths[isMobile ? "mobile" : "desktop"]}px`,
        minWidth: `${iconWidths[isMobile ? "mobile" : "desktop"]}px`,
        ...style
      }}
    >
      <div className={`
        font-weight-900
        text-color-white
        ${isMobile ? "font-size-body-small" : "font-size-body"}
      `}>
        -{discount}
        <FarmyImage
          className="icon-img full-height"
          src={image}
          style={{
            width: isMobile ? "8px" : "10px"
          }}
        />
      </div>
    </div>
    : null;
};

export default DiscountBadge;
